module.exports = __webpack_public_path__ + "img/part4@2x.4a2cf6d7.png";